module.exports = __webpack_public_path__ + "static/img/t57.6b7e3d4f.png";